import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {
    AppErrorDialogComponent,
    AppInfoDialogComponent,
    ConfirmDialogComponent,
    PrivateComponent
} from './private.component';
import {PrivateRoutingModule} from './private-routing.module';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';


import {AuthGuard} from '../services/auth-guard.service';


import {SharedModule} from '../shared/shared.module';
import {StatcollectorListComponent} from '../statcollector/statcollector-list/statcollector-list.component';
import {StatcollectorViewComponent} from '../statcollector/statcollector-view/statcollector-view.component';
import {WorkersSummaryComponent} from '../workers-summary/workers-summary.component';
import {WorkersSummaryListComponent} from '../workers-summary-list/workers-summary-list.component';
import {StatCollectorGuard} from '../statcollector/guards/statcollector.guard';
import {WorkSummaryGuard} from '../workers-summary/guards/worksummary.guard';
import {AdminGuard} from '../admin/guards/admin.guard';
import {HeaderComponent} from '../components/header.component';
import {SidebarListComponent} from '../components/sidebar-list.component';
import {BudgetGuard} from '../budget/guards/budget.guard';
import {UsersGuard} from '../users/guards/users.guard';
import {OrderGuard} from '../order/guards/order.guard';
import {InvoiceGuard} from '../invoices/invoice.guard';
import {InvoicesCosmoGuard} from '../invoices/invoices-cosmo/guards/invoices-cosmo.guard';
import {LaserCutGuard} from '../laser-cut/guards/laser-cut.guard';
import {BalancesGuard} from '../balances/balances.guard';
import {TimeReportGuard} from "../timereport/timereport.guard";

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        PrivateRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        PrivateComponent,
        SidebarListComponent,
        HeaderComponent,
        AppErrorDialogComponent,
        AppInfoDialogComponent,
        ConfirmDialogComponent,
        StatcollectorListComponent,
        StatcollectorViewComponent,
        WorkersSummaryComponent,
        WorkersSummaryListComponent
    ],
    providers: [
        AuthGuard,
        BudgetGuard,
        OrderGuard,
        InvoiceGuard,
        WorkSummaryGuard,
        StatCollectorGuard,
        UsersGuard,
        InvoicesCosmoGuard,
        LaserCutGuard,
        BalancesGuard,
        AdminGuard,
        DatePipe,
        StatCollectorGuard,
        WorkSummaryGuard,
        TimeReportGuard
    ]
})
export class PrivateModule {
}
